export default "__VITE_ASSET__CvZpB5Ss__"